import React from "react";
import {Input, Button, Row, Col, Icon, Tooltip, Popconfirm, notification, Tag, Modal, Table, Select} from "antd";
import PageLayout from "../../ui/PageLayout";
import http from "../../../axios/http";
import messager from "../../ui/messager";
import { getBase64 } from "../../../util/util.js";
import PlateNoCardEdit from "./PlateNoCardEdit";
import server from "../../../axios/server";
import { global_data } from '../../ui/auth'

const deleteNotification = (type) => {
  notification[type]({
    message: "删除成功",
  });
};

class PlateNoCardIndex extends React.Component {
  columns = [
    {
      title: "车牌号",
      dataIndex: "plateNo",
      width: "12%",
    },
    {
      title: "商户",
      dataIndex: "memberName",
      width: "13%",
      render: (text, record, index) => <div>{text || record.memberCode}</div>,
    },
    {
      title: "白名单类型",
      dataIndex: "typeStr",
      width: "10%",
    },
    {
      title: "缴费金额",
      dataIndex: "paymentAmount",
      width: "10%",
    },
    {
      title: "姓名",
      dataIndex: "name",
      width: "10%",
    },
    {
      title: "有效区域",
      dataIndex: "useZone",
      width: "30%",
      render: (text, record, index) => {
        var temp = text.split(",");
        var zoneArr = [];
        temp.forEach((item) => {
          this.state.parkZones.forEach((row) => {
            if (row.code === item) {
              zoneArr.push(row.name);
            }
          });
        });
        return zoneArr.join(",");
      },
    },
    {
      title: "备注",
      dataIndex: "remark",
      width: "20%",
    },
    {
      title: "起始日期",
      dataIndex: "startDate",
      width: "12%",
    },
    {
      title: "有效期至",
      dataIndex: "expireDate",
      width: "12%",
    },
    {
      title: "状态",
      dataIndex: "state",
      width: "10%",
      render: (text, record, index) => (
        <div>
          <Tooltip title={record.disabled ? "切换启用" : "切换禁用"}>
          {global_data.authCode.includes("BARRIER_WHITE_LIST_ENABLE")?
            <Button
              onClick={this.changeDisabled.bind(this, record)}
              style={{ color: record.disabled ? "red" : "black" }}
            >
              {record.disabled ? "禁用" : "启用"}
            </Button>
            :""}
          </Tooltip>
        </div>
      ),
    },
    {
      title: "审核状态",
      dataIndex: "reviewStatus",
      width: "10%",
      render: (text, record, index) => (
          <div>
            <Tag color={record.reviewStatusStr === '待审核' ? 'green' : record.reviewStatusStr === '审核不通过' ? 'orange' : record.reviewStatusStr === '审核通过' ? 'blue' : 'cyan'}>{record.reviewStatusStr}</Tag>
          </div>
      ),
    },
    {
      title: "操作",
      dataIndex: "id",
      width: "18%",
      render: (text, record, index) => (
        <div>
            {global_data.authCode.includes("BARRIER_WHITE_LIST_DETAIL") ?
              <Tooltip title="审核详情">
                <Icon type="eye" theme="filled" className="table-operate-icon"
                      onClick={this.operationDetail.bind(this, record)}/>
              </Tooltip>
              : ""}
            {global_data.authCode.includes("BARRIER_WHITE_LIST_UPDATE") && record.reviewStatusStr !== '待审核'?
                <Tooltip title="修改">
                  <Icon
                      type="edit"
                      theme="filled"
                      title="修改"
                      className="table-operate-icon"
                      onClick={this.update.bind(this, record)}
                  />
                </Tooltip>
                :""}
            <Popconfirm
                title="确定删除此项记录?"
                onConfirm={this.deleteConfirm.bind(this, record)}
                onCancel={this.deleteCancel.bind(this, record)}
                okText="Yes"
                cancelText="No"
            >
              {global_data.authCode.includes("BARRIER_WHITE_LIST_DELETE") && record.reviewStatusStr !== '待审核'?
                  <Tooltip title="删除">
                    <Icon
                        type="delete"
                        theme="filled"
                        title="删除"
                        className="table-operate-icon"
                    />
                  </Tooltip>
                  :""}
            </Popconfirm>
          <Popconfirm
              title="确定提交此项记录?提交状态不可进行更改!"
              onConfirm={this.submit.bind(this, record)}
              onCancel={this.submit.bind(this, record)}
              okText="Yes"
              cancelText="No"
          >
            {global_data.authCode.includes("BARRIER_WHITE_LIST_SUBMIT") && record.reviewStatusStr === '保存'?
                <Tooltip title="提交">
                  <Icon
                      type="tag"
                      theme="filled"
                      title="提交"
                      className="table-operate-icon"
                  />
                </Tooltip>
                :""}
          </Popconfirm>
        </div>
      ),
    },
    {
      title: "审核",
      dataIndex: "",
      width: "18%",
      hidden: !global_data.authCode.includes("BARRIER_WHITE_LIST_REVIEW"),
      render: (text, record, index) => (
          <div>
            {
              record.reviewStatusStr === '待审核'&&((global_data.authCode.includes("BARRIER_WHITE_LIST_REVIEW_FINANCE")&&record.type===1)||(global_data.authCode.includes("BARRIER_WHITE_LIST_REVIEW_MANAGER")&&(record.type===2||record.type===0)))?
                  <div style={{display: 'inline'}}>
                    <Popconfirm
                        title="确定通过此项记录?"
                        onConfirm={this.reviewConfirm.bind(this, record, 1)}
                        okText="Yes"
                        cancelText="No"
                    >
                      <Button type="primary">
                        通过
                      </Button>
                    </Popconfirm>

                    <Popconfirm
                        title="确定驳回此项记录?"
                        onConfirm={this.reviewConfirm.bind(this, record, 0)}
                        okText="Yes"
                        cancelText="No"
                    >
                      <Button type="danger" style={{marginLeft: "10px"}}>
                        驳回
                      </Button>
                    </Popconfirm>
                  </div>:""
            }
          </div>
      ),
    },
  ];

  column = this.columns.filter(item=>!item.hidden);

  operationDetailColumns = [
    {
      title: '操作时间',
      dataIndex: 'time',
      width: '20%',
    },
    {
      title: '操作人',
      dataIndex: 'name',
      width: '10%',
    },
    {
      title: '状态',
      dataIndex: 'status',
      width: '10%',
    },
    {
      title: '说明',
      dataIndex: 'info',
      width: '20%',
      render: (text, record, index) => (
          <Tooltip title={text}>
            <span>{text}</span>
          </Tooltip>
      )
    },
  ];


  loadAllZone = () => {
    http.post({
      url: "/barrier/parkZone/allZone",
      data: {},
      success: (res) => {
        this.setState({ parkZones: res });
      },
    });
  };
  componentWillMount() {
    this.loadBarrierMember();
    this.loadAllZone();
  }

  state = {
    visible: false,
    editData: {},
    loadData: "",
    queryData: {},
    parkZones: [],
    showOperationDetail: false,
    operationDetailDataSource: [],
    members: []
  };

  add = () => {
    this.setState({ editData: { state: 1 } });
    this.showModal();
  };

  showModal = () => {
    this.setState({ visible: true });
  };
  hiddenModal = () => {
    this.setState({ visible: false });
  };

  changeDisabled = (data, e) => {
    console.log(data);
    const { id, disabled } = data;
    http.post({
      url: "/barrier/plateNoCard/setDisabled",
      data: { id, disabled: disabled ? 0 : 1 },
      success: (res) => {
        this.refreshWhiteList(data);
        this.state.loadData(this.state.queryData);
      },
    });
  };

  update = (info, e) => {
    info.useZoneArr = info.useZone.split(",");
    this.setState({ editData: info });
    this.showModal();
  };

  deleteConfirm = (info, e) => {
    http.post({
      url: "/barrier/plateNoCard/delete",
      data: { id: info.id },
      success: (res) => {
        this.refreshWhiteList(info);
        deleteNotification("success");
        let queryData = this.state.queryData;
        this.state.loadData(queryData);
      },
    });
  };
  reviewConfirm = (info, flag, e) => {
    http.post({
      url: "/barrier/plateNoCard/setReviewStatus",
      data: { id: info.id, reviewStatus: flag },
      success: (res) => {
        this.refreshWhiteList(info);
        let queryData = this.state.queryData;
        this.state.loadData(queryData);
      },
    });
  };
  submit = (info) => {
    http.post({
      url: "/barrier/plateNoCard/submit",
      data: { id: info.id },
      success: (res) => {
        this.refreshWhiteList(info);
        let queryData = this.state.queryData;
        this.state.loadData(queryData);
      },
    });
  };
  operationDetail=(info) => {
    this.setState({ operationDetailDataSource: [] });
    http.post({
      url: "/barrier/plateNoCard/getOperationRecordList",
      data: { id: info.id },
      success: (res) => {
        this.setState({ operationDetailDataSource: res || [], showOperationDetail: true, currentOperationRecord: info });
      },
    });
  };

  closeOperationDetail = () => {
    this.setState({ showOperationDetail: false });
  };

  renderOperationDetailModal = () => {
    const {
      showOperationDetail,
      operationDetailDataSource,
      currentOperationRecord
    } = this.state;

    return (
        <Modal
            title={`流程详情 - ${currentOperationRecord?.plateNo || ''}`}
            visible={showOperationDetail}
            onCancel={this.closeOperationDetail}
            width={800}
            footer={null}
        >
          <Table
              dataSource={operationDetailDataSource}
              columns={this.operationDetailColumns}
              rowKey="id"
              pagination={{
                pageSize: 10,
                showSizeChanger: false
              }}
              bordered
              size="middle"
          />
        </Modal>
    );
  };

  loadBarrierMember() {
    http.post({
      url: "/barrier/plateNoCard/allMembers",
      success: (res) => {
        this.setState({ members: res });
      },
    });
  }
  memberCodeChange = (val) => {
    let queryData = this.state.queryData;
    queryData["memberCode"] = val;
    this.setState({queryData: queryData});
    this.state.loadData(queryData);
  };
  reviewStatusChange = (val) => {
    let queryData = this.state.queryData;
    queryData["reviewStatus"] = val;
    this.setState({queryData: queryData});
    this.state.loadData(queryData);
  };

  refreshWhiteList=(info) => {
    http.post({
      url:server.mallServerUrl+"/externalApi/barrier/updatePlateNoWLCache",
      data: { plateNo: info.plateNo },
      success: (res) => {
        console.log("mallapi白名单缓存刷新成功");
      },
    });
  };

  deleteCancel = (info, e) => {};

  inputSearch = (value) => {
    let queryData = this.state.queryData;
    queryData["plateNo"] = value;
    this.setState({ queryData: queryData });
    this.state.loadData(queryData);
  };
  uploadFile = (e) => {
    this.setState({ loadingVisible: true });
    let file = e.target.files[0];
    getBase64(file).then((base64) => {
      http.post({
        url: "/barrier/plateNoCard/import",
        data: {
          fileData: base64,
        },
        success: (res) => {
          http.post({
            url: server.mallServerUrl + "/externalApi/barrier/refreshWLCache",
            data: {},
            success: (res) => {
              console.log("mallapi白名单整体缓存刷新成功");
            },
          });
          this.setState({ loadingVisible: false });
          messager.notify("上传成功！");
          this.state.loadData(this.state.queryData);
        },
        error: (res) => {
          messager.alert(res);
          this.setState({ loadingVisible: false });
        },
      });
    });
    e.target.value = "";
  };
  //导出
  download = () => {
    let queryData = this.state.queryData;
    queryData.pageSize = 5000;
    this.setState({ loadingVisible: true });
    let fileName = "白名单.xlsx";
    http.download({
      url: '/barrier/plateNoCard/export',
      data: queryData,
      fileName: fileName,
      success: (res) => {
        this.setState({ loadingVisible: false });
      }
  });
    messager.notify("会根据查询条件导出数据！");
  }
  render() {
    const {  members } = this.state;
    return (
      <div style={{ width: "100%", height: "100%" }}>
        <PageLayout
          condition={
            <Row>
              <Col span={8}>
                <Input.Search
                  placeholder="车牌号或姓名"
                  onSearch={this.inputSearch}
                  enterButton
                />

              </Col>
              <Col span={2} >
                <Select showSearch allowClear={true} style={{ width: 120, marginLeft: '10px', marginRight: '10px' }} onChange={this.memberCodeChange} placeholder="商户:" filterOption={(input, option) =>
                    option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }>
                  {members &&
                      members.map((item, index) => (
                          <Select.Option key={item.id} value={item.code}>
                            {item.name}
                          </Select.Option>
                      ))}
                </Select>
              </Col>
              <Col span={2} >
                <Select allowClear={true} style={{ width: 120, marginLeft: '10px', marginRight: '10px' }} onChange={this.reviewStatusChange} placeholder="审核状态:" >
                  <Select.Option value={"VERIFY_SAVE"}>保存</Select.Option>
                  <Select.Option value={"VERIFYING"}>待审核</Select.Option>
                  <Select.Option value={"VERIFY_PASS"}>审核通过</Select.Option>
                  <Select.Option value={"VERIFY_FAIL"}>审核不通过</Select.Option>
                </Select>
              </Col>
              <Col span={6} style={{ textAlign: "right" }}>
                {global_data.authCode.includes("BARRIER_WHITE_LIST_ADD")?
                <Button type="primary" onClick={this.add}>
                  新增
                </Button>
                :""}
                <Button type="primary" onClick={this.download.bind(this)} style={{ float: "right", marginLeft: "5px" }} >导出</Button>
                {global_data.authCode.includes("BARRIER_WHITE_LIST_DOWNLOAD")?
                <Button
                  type="primary"
                  onClick={() => {
                    window.location.href =
                      process.env.PUBLIC_URL +
                      "/templateXlsx/carWhiteList.xlsx";
                  }}
                  style={{ float: "right", marginLeft: "5px" }}
                >
                  下载模板
                </Button>
                :""}
                {global_data.authCode.includes("BARRIER_WHITE_LIST_IMPORT")?
                <Button
                  type="primary"
                  onClick={() => {
                    this.refs.fileInput.click();
                  }}
                  style={{ float: "right", marginLeft: "5px" }}
                >
                  导入
                </Button>
                :""}
                <input
                  type="file"
                  accept=".xlsx"
                  onChange={this.uploadFile.bind(this)}
                  style={{ display: "none" }}
                  ref="fileInput"
                />
              </Col>
            </Row>
          }
          rowKey="id"
          url="/barrier/plateNoCard/query"
          columns={this.column}
          loadData={(func) => {
            this.setState({ loadData: func });
          }}
        />
        <PlateNoCardEdit
          visible={this.state.visible}
          onCancel={this.hiddenModal.bind(this)}
          editData={this.state.editData}
          successCallback={this.state.loadData}
          queryData={this.state.queryData}
        />
        {this.renderOperationDetailModal()}
      </div>
    );
  }
}

export default PlateNoCardIndex;
